module.exports = __webpack_public_path__ + "img/logo.c2658149.svg";